import React from 'react';
import FinancialReportsPanel from '../FinancialReportsPanel';

const FinancialReportsWorkspace = ({
  report,
  formatCurrency,
  onNavigate
}) => {
  return (
    <FinancialReportsPanel
      report={report}
      formatCurrency={formatCurrency}
      onNavigate={onNavigate}
    />
  );
};

export default FinancialReportsWorkspace;
